import en from './en.json'
import zh from './zh-Hans.json'
import th from './th-TH.json'
import pt from './pt.json'
export default {
	zh,
	en,
	th,
	pt
}